<template>
    <BasicTabs :tabs="tabs" :tab-key="tabKey" :title="$t('vue.settings')">
        <slot />
    </BasicTabs>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import {
    UserIcon,
    UserGroupIcon,
    LockClosedIcon,
} from "@heroicons/vue/24/solid";
import route from "ziggy-js";
import type TabItem from "@/types/Settings/TabItem";
import { useTranslations } from "@/composables/useTranslations";
import { Settings } from "lucide-vue-next";

defineProps({
    tabKey: {
        type: String,
        default: "profile",
    },
});

const { t } = useTranslations();

const isProfileEdit = computed(
    () => route().current() === "settings.profile-settings.index",
);

const isSecuritySettings = computed(
    () => route().current() === "settings.security-settings.index",
);

const tabs: TabItem[] =
    isProfileEdit.value || isSecuritySettings.value
        ? [
              {
                  title: t("vue.profile"),
                  key: "profile-settings",
                  icon: UserIcon,
                  url: route("settings.profile-settings.index"),
              },
              {
                  title: t("vue.password_and_security"),
                  key: "security-settings",
                  icon: LockClosedIcon,
                  url: route("settings.security-settings.index"),
              },
          ]
        : [
              {
                  title: t("vue.team_settings"),
                  key: "team-settings",
                  icon: UserGroupIcon,
                  url: route("settings.team-settings.index"),
              },
              {
                  title: t("vue.team_settings_api_tokens"),
                  key: "team-settings-api-tokens",
                  icon: Settings,
                  url: route("settings.api-tokens.index"),
              },
          ];
</script>
